// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8e889764","316":"b1b029cc","455":"0258bd5d","977":"525a71e2"}[chunkId] + ".chunk.js";
};